var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomFlooding({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 14,
    viewBox: "0 0 50 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M49.946 5.672c-4.989 0-5-4.672-9.989-4.672-4.989 0-5 4.672-9.99 4.672-4.988 0-5-4.672-9.988-4.672-4.99 0-5 4.672-9.99 4.672C5 5.672 5 1 0 1v13h49.928c.09-5.552.096-8.328.018-8.328z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M50 5c-4.994 0-5.006-4-10-4s-5.006 4-10 4-5.006-4-10-4-5.006 4-10 4S5.006 1 0 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomFlooding);
export default __webpack_public_path__ + "static/media/RoomFlooding.bd242899e3cb35bf56fd402d3ae36d41.svg";
export { ForwardRef as ReactComponent };